import { AxiosResponse } from 'axios';
import { api } from './companiesApi';

export const getBranchOffices = async (
	params?: any,
): Promise<AxiosResponse> => {
	return await api.get('/branch-offices', { params });
};

export const getInsurance = async (): Promise<AxiosResponse> => {
	return await api.get('/insurances');
};
